/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useRef, useCallback, useState } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { format } from 'date-fns';
import Modal from '../../../../components/Modal';
import DatePicker from '../../../../components/DatePicker';
import Button from '../../../../components/Button';
import { Container } from './styles';

interface RechargeOrderFilterModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
  handleApplyFilter(filters: any): void;
}

const RechargeOrderFilterModal: React.FC<RechargeOrderFilterModalProps> = ({
  handleClose,
  handleApplyFilter,
  show,
  title,
}) => {
  const formTableRef = useRef<FormHandles>(null);

  const [defaultStart, setDefaultStart] = useState<string>(() => {
    const start = localStorage.getItem('@TransfacilPJ:start_date');
    if (start) return start;
    return '';
  });
  const [defaultEnd, setDefaultEnd] = useState<string>(() => {
    const end = localStorage.getItem('@TransfacilPJ:end_date');
    if (end) return end;
    return '';
  });

  const handleSubmit = useCallback((data: any) => {
    const formatedData = {
      end_date: data.end_date ? format(data.end_date, 'dd/MM/yyyy') : '',
      start_date: data.start_date ? format(data.start_date, 'dd/MM/yyyy') : '',
    };
    handleApplyFilter(formatedData);
    localStorage.setItem('@TransfacilPJ:start_date', formatedData.start_date);
    localStorage.setItem('@TransfacilPJ:end_date', formatedData.end_date);
  }, []);

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <Form ref={formTableRef} onSubmit={handleSubmit}>
          <p style={{ marginBottom: '10px', marginTop: '0' }}>Período</p>

          <DatePicker
            name="start_date"
            label="De"
            placeholder="Digite a data"
            value={defaultStart}
            onSelect={value => setDefaultStart(format(value, 'dd/MM/yyyy'))}
          />

          <DatePicker
            name="end_date"
            label="Até"
            placeholder="Digite a data"
            value={defaultEnd}
            onSelect={value => setDefaultEnd(format(value, 'dd/MM/yyyy'))}
          />
          <div className="buttonsContainer">
            <Button color="orange" padding="1" type="submit">
              Aplicar Filtros
            </Button>
          </div>
        </Form>
      </Modal>
    </Container>
  );
};

export default RechargeOrderFilterModal;
